$('.c-ancla-footer__link').on('click',function(){
    // cambiar a hred luego por accesibilidad
    $('html,body').animate({ scrollTop: 0 }, 1500, function () {
        $('.c-site-header__logo').focus();
    });
});
